// import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
// import ServitorSiteNavbar from "./ServitorSiteNavbar";

// // A custom component wrapping NavLink to add hover and active inline styles.
// const StyledNavLink = ({ to, icon, children, ...props }) => {
//   const [isHovered, setIsHovered] = useState(false);

//   return (
//     <NavLink
//       to={to}
//       {...props}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       // The style function applies styles based on the isActive and isHovered flags.
//     //   style={({ isActive }) => ({
//     //     textDecoration: "none",
//     //     color: "inherit",
//     //     backgroundColor: isActive
//     //       ? "#10b981" // active background
//     //       : isHovered
//     //       ? "#f7f7f7" // hover background
//     //       : "transparent",
//     //     padding: "8px 15px",
//     //     borderRadius: "5px",
//     //     transition: "background-color 0.3s ease",
//     //     display: "block",
//     //     marginBottom: "5px",
//     //   })}
//     // >
//     //   {children}
//     className={({ isActive }) => 
//       `ServitorSiteLayout-navLink ${isActive ? "ServitorSiteLayout-navLink-active" : ""}`
//     }
//     style={({ isActive }) => ({
//       backgroundColor: isActive
//         ? "#10b981" // active background (teal)
//         : isHovered
//         ? "#c2ebdc" // hover background (light gray)
//         : "transparent",
//       color: isActive ? "white" : "inherit",
//     })}
//   >
//     <i className={`${icon} ServitorSiteLayout-navLink-icon`}></i>
//     <span className="ServitorSiteLayout-navLink-text">{children}</span>
//     </NavLink>
//   );
// };

// const ServitorSiteLayout = ({
//   servitor,
//   handleLogout,
//   getStatusClass,
//   children,
// }) => {
//   return (
//     <div className="servitorsite-container">
//       {/* Top Navbar */}
//       <ServitorSiteNavbar servitor={servitor} handleLogout={handleLogout} />

//       <div className="ServitorSiteLayout-content-wrapper">
//       {/* Sidebar */}
//       <nav className="servitorsite-sidebar">
//         <div className="servitorsite-profile-section">
//           <img
//             src={
//               servitor.image
//                 ? `http://localhost:4001/uploads/${servitor.image}`
//                 : "https://via.placeholder.com/150"
//             }
//             alt="Servitor"
//             className="servitorsite-profile-img"
//           />
//           <h4 className="servitorsite-profile-name">
//             {servitor.FirstName} {servitor.LastName}
//           </h4>
//           <div
//             className={`servitorsite-status-container ${getStatusClass(
//               servitor.approve_status
//             )}`}
//           >
//             {servitor.approve_status === "Approved" && (
//               <>
//                 <i className="bx bxs-check-shield servitorsite-status-icon"></i>
//                 <span>{servitor.approve_status}</span>
//               </>
//             )}
//             {servitor.approve_status === "Pending" && (
//               <>
//                 <i className="bx bxs-hourglass-bottom servitorsite-status-icon"></i>
//                 <span>{servitor.approve_status}</span>
//               </>
//             )}
//             {servitor.approve_status === "Blocked" && (
//               <>
//                 <i className="bx bxs-error-alt servitorsite-status-icon"></i>
//                 <span>{servitor.approve_status}</span>
//               </>
//             )}
//           </div>
//         </div>
//         {/* <div>
//           <p>Availability: {servitor.availability}</p>
//         </div> */}
//         <hr />
//         <ul className="servitorsite-nav-links">
//           {/* Use the "end" prop on the Dashboard link so that it is active only when URL exactly matches "/servitor" */}
//           <li className="ServitorSiteLayout-nav-item">
//             <StyledNavLink to="/servitor" end icon="bx bx-list-ul">
//             Orders
//             </StyledNavLink>
//           </li>
//           {servitor.approve_status === "Approved" && (
//             <>
//               {/* <li>
//                 <StyledNavLink to="/servitor" end>
//                   Orders
//                 </StyledNavLink>
//               </li> */}
//               <li className="ServitorSiteLayout-nav-item">
//                 <StyledNavLink to="/servitor/accepted-orders" end icon="bx bx-check">
//                   Accepted Orders
//                 </StyledNavLink>
//               </li>
//               <li className="ServitorSiteLayout-nav-item">
//                 <StyledNavLink to="/servitor/complete-orders" end icon="bx bx-clipboard">
//                   Complete Orders
//                 </StyledNavLink>
//               </li>

//               <li className="ServitorSiteLayout-nav-item">
//               <StyledNavLink to="/servitor/notifications" icon="bx bx-bell">
//                 Notifications
//               </StyledNavLink>
//             </li>
//             </>
//           )}
//           {/* <li className="servitorsite-logout" onClick={handleLogout}>
//             Logout
//           </li> */}

//           <li 
//               className="ServitorSiteLayout-nav-item ServitorSiteLayout-logout"
//               onClick={handleLogout}
//             >
//               <div className="ServitorSiteLayout-navLink">
//                 <i className="bx bx-log-out ServitorSiteLayout-navLink-icon"></i>
//                 <span className="ServitorSiteLayout-navLink-text" style={{color: "#FF3B30"}}>Logout</span>
//               </div>
//             </li>

//         </ul>
//       </nav>

//       {/* Main Content */}
//       <div className="servitorsite-main-content">{children}</div>
//       </div>
//     </div>
//   );
// };

// export default ServitorSiteLayout;










// ******** All design and operations are okay ********* //

// import React, { useState, useEffect, useRef } from "react";
// import { NavLink } from "react-router-dom";
// import ServitorSiteNavbar from "./ServitorSiteNavbar";

// // A custom component wrapping NavLink to add hover and active inline styles.
// const StyledNavLink = ({ to, icon, children, ...props }) => {
//   const [isHovered, setIsHovered] = useState(false);

//   return (
//     <NavLink
//       to={to}
//       {...props}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       // The style function applies styles based on the isActive and isHovered flags.
//     //   style={({ isActive }) => ({
//     //     textDecoration: "none",
//     //     color: "inherit",
//     //     backgroundColor: isActive
//     //       ? "#10b981" // active background
//     //       : isHovered
//     //       ? "#f7f7f7" // hover background
//     //       : "transparent",
//     //     padding: "8px 15px",
//     //     borderRadius: "5px",
//     //     transition: "background-color 0.3s ease",
//     //     display: "block",
//     //     marginBottom: "5px",
//     //   })}
//     // >
//     //   {children}
//     className={({ isActive }) => 
//       `ServitorSiteLayout-navLink ${isActive ? "ServitorSiteLayout-navLink-active" : ""}`
//     }
//     style={({ isActive }) => ({
//       backgroundColor: isActive
//         ? "#10b981" // active background (teal)
//         : isHovered
//         ? "#c2ebdc" // hover background (light gray)
//         : "transparent",
//       color: isActive ? "white" : "inherit",
//     })}
//   >
//     <i className={`${icon} ServitorSiteLayout-navLink-icon`}></i>
//     <span className="ServitorSiteLayout-navLink-text">{children}</span>
//     </NavLink>
//   );
// };

// const ServitorSiteLayout = ({
//   servitor,
//   handleLogout,
//   getStatusClass,
//   children,
// }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const sidebarRef = useRef(null);
//   const menuButtonRef = useRef(null);

//   // Function to handle sidebar toggle
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Function to check window size
//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth < 992);
//       setSidebarOpen(window.innerWidth >= 992);
//     };

//     // Initial check
//     checkScreenSize();

//     // Add event listener
//     window.addEventListener("resize", checkScreenSize);

//     // Cleanup
//     return () => {
//       window.removeEventListener("resize", checkScreenSize);
//     };
//   }, []);

//   // Add click outside listener
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Only close sidebar on mobile when clicking outside
//       if (!isMobile || !sidebarOpen) return;

//       // Don't close if clicking on the sidebar itself
//       if (sidebarRef.current && sidebarRef.current.contains(event.target)) {
//         return;
//       }

//       // Don't close if clicking on the hamburger menu button
//       if (
//         menuButtonRef.current &&
//         menuButtonRef.current.contains(event.target)
//       ) {
//         return;
//       }

//       // Close the sidebar for any other click
//       setSidebarOpen(false);
//     };

//     // Add the event listener to the document
//     document.addEventListener("mousedown", handleClickOutside);
//     document.addEventListener("touchstart", handleClickOutside);

//     // Cleanup
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.removeEventListener("touchstart", handleClickOutside);
//     };
//   }, [isMobile, sidebarOpen]);

//   return (
//     <div className="servitorsite-container">
//       {/* Top Navbar */}
//       <ServitorSiteNavbar
//         servitor={servitor}
//         handleLogout={handleLogout}
//         toggleSidebar={toggleSidebar}
//         isMobile={isMobile}
//       />

//       <div className="ServitorSiteLayout-content-wrapper">
//         {/* Sidebar */}
//         <nav
//           className={`servitorsite-sidebar ${
//             sidebarOpen ? "sidebar-open" : "sidebar-closed"
//           }`}
//         >
//           <div className="servitorsite-profile-section">
//             <img
//               src={
//                 servitor.image
//                   ? `http://localhost:4001/uploads/${servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="servitorsite-profile-img"
//             />
//             <h4 className="servitorsite-profile-name">
//               {servitor.FirstName} {servitor.LastName}
//             </h4>
//             <div
//               className={`servitorsite-status-container ${getStatusClass(
//                 servitor.approve_status
//               )}`}
//             >
//               {servitor.approve_status === "Approved" && (
//                 <>
//                   <i className="bx bxs-check-shield servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//               {servitor.approve_status === "Pending" && (
//                 <>
//                   <i className="bx bxs-hourglass-bottom servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//               {servitor.approve_status === "Blocked" && (
//                 <>
//                   <i className="bx bxs-error-alt servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           {/* <div>
//           <p>Availability: {servitor.availability}</p>
//         </div> */}
//           <hr />
//           <ul className="servitorsite-nav-links">
//             {/* Use the "end" prop on the Dashboard link so that it is active only when URL exactly matches "/servitor" */}
//             <li className="ServitorSiteLayout-nav-item">
//               <StyledNavLink to="/servitor" end icon="bx bx-list-ul">
//                 Orders
//               </StyledNavLink>
//             </li>
//             {servitor.approve_status === "Approved" && (
//               <>
//                 {/* <li>
//                 <StyledNavLink to="/servitor" end>
//                   Orders
//                 </StyledNavLink>
//               </li> */}
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/accepted-orders"
//                     end
//                     icon="bx bx-check"
//                   >
//                     Accepted Orders
//                   </StyledNavLink>
//                 </li>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/complete-orders"
//                     end
//                     icon="bx bx-clipboard"
//                   >
//                     Complete Orders
//                   </StyledNavLink>
//                 </li>

//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink to="/servitor/notifications" icon="bx bx-bell">
//                     Notifications
//                   </StyledNavLink>
//                 </li>
//               </>
//             )}
//             {/* <li className="servitorsite-logout" onClick={handleLogout}>
//             Logout
//           </li> */}

//             <li
//               className="ServitorSiteLayout-nav-item ServitorSiteLayout-logout"
//               onClick={handleLogout}
//             >
//               <div className="ServitorSiteLayout-navLink">
//                 <i className="bx bx-log-out ServitorSiteLayout-navLink-icon"></i>
//                 <span
//                   className="ServitorSiteLayout-navLink-text"
//                   style={{ color: "#FF3B30" }}
//                 >
//                   Logout
//                 </span>
//               </div>
//             </li>
//           </ul>
//         </nav>

//         {/* Backdrop for mobile */}
//         {isMobile && sidebarOpen && (
//           <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
//         )}

//         {/* Main Content */}
//         <div
//           className={`servitorsite-main-content ${
//             sidebarOpen && isMobile ? "content-pushed" : ""
//           }`}
//         >
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServitorSiteLayout;













// ******** Update for responsive sidebar navlink work sidebar open ********* //

// import React, { useState, useEffect, useRef } from "react";
// import { NavLink, useNavigate } from "react-router-dom"; // CHANGE: Added useNavigate import for programmatic navigation
// import ServitorSiteNavbar from "./ServitorSiteNavbar";

// // A custom component wrapping NavLink to add hover and active inline styles.
// const StyledNavLink = ({ to, icon, children, ...props }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const navigate = useNavigate(); // CHANGE: Added useNavigate hook for custom navigation handling

//   // CHANGE: Added handleClick function to stop event propagation and navigate programmatically
//   const handleClick = (e) => {
//     // Stop event propagation to prevent handleClickOutside from closing the sidebar
//     e.stopPropagation();
//     // Perform navigation
//     navigate(to);
//   };

//   return (
//     <NavLink
//       to={to}
//       {...props}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onClick={handleClick} // CHANGE: Added onClick with handleClick to manage navigation
//       className={({ isActive }) =>
//         `ServitorSiteLayout-navLink ${isActive ? "ServitorSiteLayout-navLink-active" : ""}`
//       }
//       style={({ isActive }) => ({
//         backgroundColor: isActive
//           ? "#10b981" // active background (teal)
//           : isHovered
//           ? "#c2ebdc" // hover background (light gray)
//           : "transparent",
//         color: isActive ? "white" : "inherit",
//       })}
//     >
//       <i className={`${icon} ServitorSiteLayout-navLink-icon`}></i>
//       <span className="ServitorSiteLayout-navLink-text">{children}</span>
//     </NavLink>
//   );
// };

// const ServitorSiteLayout = ({
//   servitor,
//   handleLogout,
//   getStatusClass,
//   children,
// }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const sidebarRef = useRef(null);
//   const menuButtonRef = useRef(null);

//   // Function to handle sidebar toggle
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Function to check window size
//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth < 992);
//       setSidebarOpen(window.innerWidth >= 992);
//     };

//     // Initial check
//     checkScreenSize();

//     // Add event listener
//     window.addEventListener("resize", checkScreenSize);

//     // Cleanup
//     return () => {
//       window.removeEventListener("resize", checkScreenSize);
//     };
//   }, []);

//   // Add click outside listener
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Only close sidebar on mobile when clicking outside
//       if (!isMobile || !sidebarOpen) return;

//       // Don't close if clicking on the sidebar itself
//       if (sidebarRef.current && sidebarRef.current.contains(event.target)) {
//         return;
//       }

//       // Don't close if clicking on the hamburger menu button
//       if (
//         menuButtonRef.current &&
//         menuButtonRef.current.contains(event.target)
//       ) {
//         return;
//       }

//       // Close the sidebar for any other click
//       setSidebarOpen(false);
//     };

//     // Add the event listener to the document
//     document.addEventListener("mousedown", handleClickOutside);
//     document.addEventListener("touchstart", handleClickOutside);

//     // Cleanup
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.removeEventListener("touchstart", handleClickOutside);
//     };
//   }, [isMobile, sidebarOpen]);

//   return (
//     <div className="servitorsite-container">
//       {/* Top Navbar */}
//       <ServitorSiteNavbar
//         servitor={servitor}
//         handleLogout={handleLogout}
//         toggleSidebar={toggleSidebar}
//         isMobile={isMobile}
//         menuButtonRef={menuButtonRef} // CHANGE: Added menuButtonRef prop to pass to ServitorSiteNavbar
//       />

//       <div className="ServitorSiteLayout-content-wrapper">
//         {/* Sidebar */}
//         <nav
//           ref={sidebarRef}
//           className={`servitorsite-sidebar ${
//             sidebarOpen ? "sidebar-open" : "sidebar-closed"
//           }`}
//         >
//           <div className="servitorsite-profile-section">
//             <img
//               src={
//                 servitor.image
//                   ? `http://localhost:4001/uploads/${servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="servitorsite-profile-img"
//             />
//             <h4 className="servitorsite-profile-name">
//               {servitor.FirstName} {servitor.LastName}
//             </h4>
//             <div
//               className={`servitorsite-status-container ${getStatusClass(
//                 servitor.approve_status
//               )}`}
//             >
//               {servitor.approve_status === "Approved" && (
//                 <>
//                   <i className="bx bxs-check-shield servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//               {servitor.approve_status === "Pending" && (
//                 <>
//                   <i className="bx bxs-hourglass-bottom servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//               {servitor.approve_status === "Blocked" && (
//                 <>
//                   <i className="bx bxs-error-alt servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <hr />
//           <ul className="servitorsite-nav-links">
//             <li className="ServitorSiteLayout-nav-item">
//               <StyledNavLink to="/servitor" end icon="bx bx-list-ul">
//                 Orders
//               </StyledNavLink>
//             </li>
//             {servitor.approve_status === "Approved" && (
//               <>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/accepted-orders"
//                     end
//                     icon="bx bx-check"
//                   >
//                     Accepted Orders
//                   </StyledNavLink>
//                 </li>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/complete-orders"
//                     end
//                     icon="bx bx-clipboard"
//                   >
//                     Complete Orders
//                   </StyledNavLink>
//                 </li>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink to="/servitor/notifications" icon="bx bx-bell">
//                     Notifications
//                   </StyledNavLink>
//                 </li>
//               </>
//             )}
//             <li
//               className="ServitorSiteLayout-nav-item ServitorSiteLayout-logout"
//               onClick={(e) => {
//                 e.stopPropagation(); // CHANGE: Added stopPropagation to prevent sidebar closing on logout click
//                 handleLogout();
//               }}
//             >
//               <div className="ServitorSiteLayout-navLink">
//                 <i className="bx bx-log-out ServitorSiteLayout-navLink-icon"></i>
//                 <span
//                   className="ServitorSiteLayout-navLink-text"
//                   style={{ color: "#FF3B30" }}
//                 >
//                   Logout
//                 </span>
//               </div>
//             </li>
//           </ul>
//         </nav>

//         {/* Backdrop for mobile */}
//         {isMobile && sidebarOpen && (
//           <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
//         )}

//         {/* Main Content */}
//         <div
//           className={`servitorsite-main-content ${
//             sidebarOpen && isMobile ? "content-pushed" : ""
//           }`}
//         >
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServitorSiteLayout;











// // ******** new Update for responsive sidebar navlink work and when click sidebar close********* //

// import React, { useState, useEffect, useRef } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import ServitorSiteNavbar from "./ServitorSiteNavbar";

// // A custom component wrapping NavLink to add hover and active styles
// const StyledNavLink = ({ to, icon, children, ...props }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const navigate = useNavigate();

//   // Added onTouchEnd to handle touch events
//   const handleClick = (e) => {
//     e.stopPropagation(); // Stop event propagation to prevent handleClickOutside
//     navigate(to); // Perform navigation
//     // Trigger sidebar closure on mobile after navigation (handled by parent)
//     props.onNavClick?.();
//   };

//   return (
//     <NavLink
//       to={to}
//       {...props}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onClick={handleClick}
//       onTouchEnd={handleClick}
//       className={({ isActive }) =>
//         `ServitorSiteLayout-navLink ${isActive ? "ServitorSiteLayout-navLink-active" : ""}`
//       }
//       style={({ isActive }) => ({
//         backgroundColor: isActive
//           ? "#10b981" // active background (teal)
//           : isHovered
//           ? "#c2ebdc" // hover background (light gray)
//           : "transparent",
//         color: isActive ? "white" : "inherit",
//       })}
//     >
//       <i className={`${icon} ServitorSiteLayout-navLink-icon`}></i>
//       <span className="ServitorSiteLayout-navLink-text">{children}</span>
//     </NavLink>
//   );
// };

// const ServitorSiteLayout = ({
//   servitor,
//   handleLogout,
//   getStatusClass,
//   children,
// }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const sidebarRef = useRef(null);
//   const menuButtonRef = useRef(null);

//   // Function to handle sidebar toggle
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // NEW: Function to close sidebar after navigation in mobile mode
//   const handleNavClick = () => {
//     if (isMobile) {
//       setSidebarOpen(false);
//     }
//   };

//   // Function to check window size
//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth < 992);
//       setSidebarOpen(window.innerWidth >= 992);
//     };

//     // Initial check
//     checkScreenSize();

//     // Add event listener
//     window.addEventListener("resize", checkScreenSize);

//     // Cleanup
//     return () => {
//       window.removeEventListener("resize", checkScreenSize);
//     };
//   }, []);

//   // Add click outside listener
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Only close sidebar on mobile when clicking outside
//       if (!isMobile || !sidebarOpen) return;

//       // Don't close if clicking on the sidebar itself
//       if (sidebarRef.current && sidebarRef.current.contains(event.target)) {
//         return;
//       }

//       // Don't close if clicking on the hamburger menu button
//       if (
//         menuButtonRef.current &&
//         menuButtonRef.current.contains(event.target)
//       ) {
//         return;
//       }
//       setSidebarOpen(false);
//     };

//     // Add the event listeners
//     document.addEventListener("mousedown", handleClickOutside);
//     document.addEventListener("touchstart", handleClickOutside);
//     document.addEventListener("touchend", handleClickOutside);

//     // Cleanup
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.removeEventListener("touchstart", handleClickOutside);
//       document.removeEventListener("touchend", handleClickOutside);
//     };
//   }, [isMobile, sidebarOpen]);

//   return (
//     <div className="servitorsite-container">
//       {/* Top Navbar */}
//       <ServitorSiteNavbar
//         servitor={servitor}
//         handleLogout={handleLogout}
//         toggleSidebar={toggleSidebar}
//         isMobile={isMobile}
//         menuButtonRef={menuButtonRef}
//       />

//       <div className="ServitorSiteLayout-content-wrapper">
//         {/* Sidebar */}
//         <nav
//           ref={sidebarRef}
//           className={`servitorsite-sidebar ${
//             sidebarOpen ? "sidebar-open" : "sidebar-closed"
//           }`}
//         >
//           <div className="servitorsite-profile-section">
//             <img
//               src={
//                 servitor.image
//                   ? `http://localhost:4001/uploads/${servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Servitor"
//               className="servitorsite-profile-img"
//             />
//             <h4 className="servitorsite-profile-name">
//               {servitor.FirstName} {servitor.LastName}
//             </h4>
//             <div
//               className={`servitorsite-status-container ${getStatusClass(
//                 servitor.approve_status
//               )}`}
//             >
//               {servitor.approve_status === "Approved" && (
//                 <>
//                   <i className="bx bxs-check-shield servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//               {servitor.approve_status === "Pending" && (
//                 <>
//                   <i className="bx bxs-hourglass-bottom servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//               {servitor.approve_status === "Blocked" && (
//                 <>
//                   <i className="bx bxs-error-alt servitorsite-status-icon"></i>
//                   <span>{servitor.approve_status}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <hr />
//           <ul className="servitorsite-nav-links">
//             <li className="ServitorSiteLayout-nav-item">
//               <StyledNavLink to="/servitor" end icon="bx bx-list-ul" onNavClick={handleNavClick}>
//                 Orders
//               </StyledNavLink>
//             </li>
//             {servitor.approve_status === "Approved" && (
//               <>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/accepted-orders"
//                     end
//                     icon="bx bx-check"
//                     onNavClick={handleNavClick} // NEW: Pass handleNavClick to close sidebar
//                   >
//                     Accepted Orders
//                   </StyledNavLink>
//                 </li>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/complete-orders"
//                     end
//                     icon="bx bx-clipboard"
//                     onNavClick={handleNavClick} // NEW: Pass handleNavClick to close sidebar
//                   >
//                     Complete Orders
//                   </StyledNavLink>
//                 </li>
//                 <li className="ServitorSiteLayout-nav-item">
//                   <StyledNavLink
//                     to="/servitor/notifications"
//                     icon="bx bx-bell"
//                     onNavClick={handleNavClick} // NEW: Pass handleNavClick to close sidebar
//                   >
//                     Notifications
//                   </StyledNavLink>
//                 </li>
//               </>
//             )}
//             <li
//               className="ServitorSiteLayout-nav-item ServitorSiteLayout-logout"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleLogout();
//                 handleNavClick(); // NEW: Close sidebar on logout in mobile mode
//               }}
//             >
//               <div className="ServitorSiteLayout-navLink">
//                 <i className="bx bx-log-out ServitorSiteLayout-navLink-icon"></i>
//                 <span
//                   className="ServitorSiteLayout-navLink-text"
//                   style={{ color: "#FF3B30" }}
//                 >
//                   Logout
//                 </span>
//               </div>
//             </li>
//           </ul>
//         </nav>

//         {/* Backdrop for mobile */}
//         {isMobile && sidebarOpen && (
//           <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
//         )}

//         {/* Main Content */}
//         <div
//           className={`servitorsite-main-content ${
//             sidebarOpen && isMobile ? "content-pushed" : ""
//           }`}
//         >
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServitorSiteLayout;

// ***** Upper code All is okay checked (25-6-25) ***** //







// ***** Add Translate EN BN (25-6-25) ***** //

import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import ServitorSiteNavbar from "./ServitorSiteNavbar";
import { useTranslation } from "react-i18next";
import BalanceRecharge from "../Profile/Balance/BalanceRecharge";
import { SOCKET_URL, URL } from "../../../config";
import { io } from "socket.io-client";
import ServitorReviewModal from "../ServitorReviewModal";

// A custom component wrapping NavLink to add hover and active styles
const StyledNavLink = ({ to, icon, children, translationKey, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const { t } = useTranslation("servitor");
  

  // Added onTouchEnd to handle touch events
  const handleClick = (e) => {
    e.stopPropagation(); // Stop event propagation to prevent handleClickOutside
    navigate(to); // Perform navigation
    // Trigger sidebar closure on mobile after navigation (handled by parent)
    props.onNavClick?.();
  };

  return (
    <NavLink
      to={to}
      {...props}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      onTouchEnd={handleClick}
      className={({ isActive }) =>
        `ServitorSiteLayout-navLink ${isActive ? "ServitorSiteLayout-navLink-active" : ""}`
      }
      style={({ isActive }) => ({
        backgroundColor: isActive
          ? "#10b981" // active background (teal)
          : isHovered
          ? "#c2ebdc" // hover background (light gray)
          : "transparent",
        color: isActive ? "white" : "inherit",
      })}
      aria-label={t(`navbar.${translationKey}`)}
    >
      <i className={`${icon} ServitorSiteLayout-navLink-icon`}></i>
      <span className="ServitorSiteLayout-navLink-text">{children}</span>
    </NavLink>
  );
};

const ServitorSiteLayout = ({
  servitor,
  handleLogout,
  getStatusClass,
  children,
  refreshServitor,
}) => {
  const { t } = useTranslation("servitor");

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const [balanceVisible, setBalanceVisible] = useState(false);
  const [showBalanceModal, setShowBalanceModal] = useState(false);

  // const [socketRef, setSocketRef] = useState(null);
  const [reviewModalOrder, setReviewModalOrder] = useState(null);
  const [showServitorReviewModal, setShowServitorReviewModal] = useState(false);

  const sidebarRef = useRef(null);
  const menuButtonRef = useRef(null);

  // Function to handle sidebar toggle
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // NEW: Function to toggle balance visibility
  const toggleBalance = () => {
    setBalanceVisible(!balanceVisible);
    if (!balanceVisible) {
      setTimeout(() => {
        setBalanceVisible(false);
      }, 10000); // Auto-hide after 10 seconds
    }
  };

  // NEW: Function to toggle balance modal
  const toggleBalanceModal = () => {
    setShowBalanceModal(!showBalanceModal);
    setBalanceVisible(false); // Hide balance when opening modal
  };



  useEffect(() => {
    if (!servitor?.Id) return;
 
    // const s = io(URL, {
    //   withCredentials: true,
    //   transports: ["websocket"],
    //   auth: { servitorId: servitor.Id }, // server will auto-join servitor room
    // });

    const s = io(SOCKET_URL, {
      path: "/socket.io",
      withCredentials: true,
      transports: ["websocket", "polling"], // keep polling while testing
      auth: { servitorId: servitor.Id },
    });

 
    // optional explicit join (keeps both paths available)
    s.emit("joinServitorRoom", { servitorId: servitor.Id });
 
    s.on("connect_error", (err) => {
      console.error("Socket connect error:", err.message);
    });

    s.on("servitorProfileUpdated", (payload) => {
      refreshServitor?.();
    });

 
    s.on("orderCompletedForReview", (payload) => {

      refreshServitor?.();

      const normalized = {
        Id: payload.orderId,
        order_number: payload.orderNumber,
        userId: payload.userId,
        servitor_id: payload.servitorId,
        price: Number(payload.price || 0),
        Service: { services_name: payload.serviceType || "Unknown" },
      };
 
      // de-dupe per order_number so it doesn't pop twice
      const key = `servitor_review_prompted_${normalized.order_number}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
 
      setReviewModalOrder(normalized);
      setShowServitorReviewModal(true);
    });


    s.on("rechargeStatusUpdated", (payload) => {
    // optional: only refresh when balance changes
    if (payload?.status === "VALID") {
      refreshServitor?.();
    }
    // You could also show a toast here if you want:
    // e.g. "Your recharge of ৳X was approved"
  });
 
    // setSocketRef(s);

    // return () => s.disconnect();
    // New update
    return () => {
    s.off("servitorProfileUpdated");
    s.off("orderCompletedForReview");
    s.off("rechargeStatusUpdated");
    s.disconnect();
  };

    
  }, [servitor?.Id, refreshServitor]);



  // NEW: Function to close sidebar after navigation in mobile mode
  const handleNavClick = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  // Function to check window size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 992);
      setSidebarOpen(window.innerWidth >= 992);
    };

    // Initial check
    checkScreenSize();

    // Add event listener
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Add click outside listener
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Only close sidebar on mobile when clicking outside
      if (!isMobile || !sidebarOpen) return;

      // Don't close if clicking on the sidebar itself
      if (sidebarRef.current && sidebarRef.current.contains(event.target)) {
        return;
      }

      // Don't close if clicking on the hamburger menu button
      if (
        menuButtonRef.current &&
        menuButtonRef.current.contains(event.target)
      ) {
        return;
      }
      setSidebarOpen(false);
    };

    // Add the event listeners
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    document.addEventListener("touchend", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      document.removeEventListener("touchend", handleClickOutside);
    };
  }, [isMobile, sidebarOpen]);

  return (
    <div className="servitorsite-container">
      {/* Top Navbar */}
      <ServitorSiteNavbar
        servitor={servitor}
        handleLogout={handleLogout}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
        menuButtonRef={menuButtonRef}
      />

      <div className="ServitorSiteLayout-content-wrapper">
        {/* Sidebar */}
        <nav
          ref={sidebarRef}
          className={`servitorsite-sidebar ${
            sidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="servitorsite-profile-section">
            <img
              src={
                servitor.image
                  ? `${URL}/uploads/${servitor.image}`
                  : "https://via.placeholder.com/150"
              }
              alt="Servitor"
              className="servitorsite-profile-img"
            />
            <h4 className="servitorsite-profile-name">
              {servitor.FirstName} {servitor.LastName}
            </h4>
            <div
              className={`servitorsite-status-container ${getStatusClass(
                servitor.approve_status
              )}`}
            >
              {servitor.approve_status === "Approved" && (
                <>
                  <i className="bx bxs-check-shield servitorsite-status-icon"></i>
                  {/* <span>{servitor.approve_status}</span> */}
                  <span>{t("status.approved")}</span>
                </>
              )}
              {servitor.approve_status === "Pending" && (
                <>
                  <i className="bx bxs-hourglass-bottom servitorsite-status-icon"></i>
                  {/* <span>{servitor.approve_status}</span> */}
                  <span>{t("status.pending")}</span>
                </>
              )}
              {servitor.approve_status === "Blocked" && (
                <>
                  <i className="bx bxs-error-alt servitorsite-status-icon"></i>
                  {/* <span>{servitor.approve_status}</span> */}
                  <span>{t("status.blocked")}</span>
                </>
              )}
            </div>
          </div>

          {/* NEW: Balance Widget */}
          <div className="servitorsite-balance-widget" onClick={toggleBalance}>
            {!balanceVisible ? (
              <div className="servitorsite-balance-hidden">
                <div className="servitorsite-balance-icon-wrapper">
                  <i className="fas fa-wallet"></i>
                </div>
                <div className="servitorsite-balance-text">
                  <p className="servitorsite-balance-title">
                    {t("sidebar.balance")}
                  </p>
                  <p className="servitorsite-balance-tap">
                    {t("sidebar.tapToView")}
                  </p>
                </div>
                <div className="servitorsite-balance-dots">
                  <div className="servitorsite-balance-dot"></div>
                  <div
                    className="servitorsite-balance-dot"
                    style={{ animationDelay: "0.2s" }}
                  ></div>
                  <div
                    className="servitorsite-balance-dot"
                    style={{ animationDelay: "0.4s" }}
                  ></div>
                </div>
              </div>
            ) : (
              <div className="servitorsite-balance-revealed">
                <div className="servitorsite-balance-header">
                  <div className="servitorsite-balance-icon-wrapper">
                    <i className="fas fa-wallet"></i>
                  </div>
                  <div className="servitorsite-balance-amount">
                    <span className="servitorsite-balance-currency">৳</span>
                    <span className="servitorsite-balance-value">
                      {servitor?.balance?.toLocaleString() || 0}
                    </span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleBalanceModal();
                    }}
                    className="servitorsite-balance-recharge-btn"
                    aria-label={t("balanceRecharge.title")}
                  >
                    <i className="fas fa-plus"></i> {/* CHANGED: Only plus icon, no text (line 180) */}
                  </button>
                </div>
              </div>
            )}
          </div>


          <hr />
          <ul className="servitorsite-nav-links">
            <li className="ServitorSiteLayout-nav-item">
              <StyledNavLink to="/servitor" end icon="bx bx-list-ul" onNavClick={handleNavClick} translationKey="orders" >
                {/* Orders */}
                {t("navbar.orders")}
              </StyledNavLink>
            </li>
            {servitor.approve_status === "Approved" && (
              <>
                <li className="ServitorSiteLayout-nav-item">
                  <StyledNavLink
                    to="/servitor/accepted-orders"
                    end
                    icon="bx bx-check"
                    onNavClick={handleNavClick}
                    translationKey="accepted"
                  >
                    {/* Accepted Orders */}
                    {t("navbar.accepted")}
                  </StyledNavLink>
                </li>
                <li className="ServitorSiteLayout-nav-item">
                  <StyledNavLink
                    to="/servitor/complete-orders"
                    end
                    icon="bx bx-clipboard"
                    onNavClick={handleNavClick}
                    translationKey="completed"
                  >
                    {/* Complete Orders */}
                    {t("navbar.completed")}

                  </StyledNavLink>
                </li>

                <li className="ServitorSiteLayout-nav-item">
                  <StyledNavLink
                    to="/servitor/recharge-history"
                    end
                    icon="bx bx-wallet"
                    onNavClick={handleNavClick}
                    translationKey="rechargeHistory"
                  >
                    {/* Recharge History */}
                    {t("navbar.rechargeHistory")}
                  </StyledNavLink>
                </li>

                <li className="ServitorSiteLayout-nav-item">
                  <StyledNavLink
                    to="/servitor/transaction-history"
                    end
                    icon="bx bx-history"
                    onNavClick={handleNavClick}
                    translationKey="transactionHistory"
                  >
                    {t("navbar.transactionHistory")}
                  </StyledNavLink>
                </li>
                <li className="ServitorSiteLayout-nav-item">
                  <StyledNavLink
                    to="/servitor/servitor-rewards"
                    end
                    icon="bx bx-gift"
                    onNavClick={handleNavClick}
                    translationKey="rewards"
                  >
                    {t("navbar.rewards")}
                  </StyledNavLink>
                </li>


                <li className="ServitorSiteLayout-nav-item">
                  <StyledNavLink
                    to="/servitor/notifications"
                    icon="bx bx-bell"
                    onNavClick={handleNavClick}
                    translationKey="notifications"
                  >
                    {/* Notifications */}
                    {t("navbar.notifications")}

                  </StyledNavLink>
                </li>
              </>
            )}
            <li
              className="ServitorSiteLayout-nav-item ServitorSiteLayout-logout"
              onClick={(e) => {
                e.stopPropagation();
                handleLogout();
                handleNavClick(); // NEW: Close sidebar on logout in mobile mode
              }}
            >
              <div className="ServitorSiteLayout-navLink">
                <i className="bx bx-log-out ServitorSiteLayout-navLink-icon"></i>
                <span
                  className="ServitorSiteLayout-navLink-text"
                  style={{ color: "#FF3B30" }}
                >
                  {/* Logout */}
                  {t("navbar.logout")}

                </span>
              </div>
            </li>
          </ul>
        </nav>

        {/* Backdrop for mobile */}
        {isMobile && sidebarOpen && (
          <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
        )}

        {/* Main Content */}
        <div
          className={`servitorsite-main-content ${
            sidebarOpen && isMobile ? "content-pushed" : ""
          }`}
        >
          {children}
        </div>
      </div>

      {/* NEW: Balance Recharge Modal */}
            <BalanceRecharge
              isOpen={showBalanceModal}
              onClose={toggleBalanceModal}
              servitorId={servitor?.Id}
              currentBalance={servitor?.balance || 0}
              onBalanceUpdated={refreshServitor}
            />


            {showServitorReviewModal && reviewModalOrder && (
         <ServitorReviewModal
           order={reviewModalOrder}
           onClose={() => {
             setShowServitorReviewModal(false);
             setReviewModalOrder(null);
           }}
           onReviewSubmit={() => {
             setShowServitorReviewModal(false);
             setReviewModalOrder(null);
           }}
         />
       )}

    </div>
  );
};

export default ServitorSiteLayout;


